import classes from './FlexFill.module.scss';

export default function FlexFill() {
  return <div className={classes.root} />;
}
